import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-scroll'

import { Button } from '../../common'
import { getIsLegalFlow } from '../../../redux/slices/userSlice'

import './styles.scss'

const FilterCard = ({
	name,
	videoSrc,
	description,
	bgImgSrc,
	isLast,
	isSmall,
}) => {
	const isLegalFlow = useSelector(getIsLegalFlow)

	return (
		<div className={`filter-card ${isSmall ? 'small' : ''}`}>
			<div className="card-video-container">
				{!isSmall && (
					<img src={bgImgSrc} alt="bgImgSrc" className="card-video-bg" />
				)}
				<div className={`card-video-wrapper ${isSmall ? 'small' : ''}`}>
					<video
						autoPlay="autoplay"
						loop
						muted
						src={videoSrc}
						type="video/mp4"
						className={`card-video ${isSmall ? 'small' : ''}`}
						playsInline
					/>
				</div>
			</div>
			<h3 className={`filter-card__title ${isSmall ? 'small' : ''}`}>{name}</h3>
			{!isSmall && (
				<>
					<p className="filter-card__description">{description}</p>
					<Link
						to="price"
						smooth={true}
						duration={1000}
						spy={true}
						exact="true"
						offset={-100}
					>
						<Button buttonText={`Try ${isLegalFlow ? 'now' : 'for free'}`} />
					</Link>
				</>
			)}
			{isLast && <p className="filter-card__more">and more features ... </p>}
		</div>
	)
}

export { FilterCard }
